"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatelessReactViewController = void 0;
class StatelessReactViewController {
    constructor(defaultRenderer) {
        this.defaultRenderer = defaultRenderer;
        this.render = this.render.bind(this);
        this.createElement = this.createElement.bind(this);
    }
    createElement() {
        var _a, _b;
        return (_b = (_a = this.defaultRenderer) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : null;
    }
    render() {
        return this.createElement();
    }
}
exports.StatelessReactViewController = StatelessReactViewController;
//# sourceMappingURL=StatelessReactViewController.js.map